import { Input } from "common/src/styles";
import { ReactComponent as Search } from "../../assets/search-grey.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SortFilterDropdown = props => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("span", {
      className: "text-sm mx-auto md:ml-8",
      children: ["Sort ", /*#__PURE__*/_jsx("span", {
        className: "hidden md:inline mr-1",
        children: "by"
      })]
    }), /*#__PURE__*/_jsxs("select", {
      className: "border-0 cursor-pointer text-violet-400 text-sm",
      placeholder: "Select Filter",
      onChange: props.onChange,
      children: [/*#__PURE__*/_jsx("option", {
        value: "round_asc",
        children: "Round End (Earliest)"
      }), /*#__PURE__*/_jsx("option", {
        value: "round_desc",
        children: "Round Start (Earliest)"
      })]
    })]
  });
};
export const SearchInput = props => {
  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    children: [/*#__PURE__*/_jsx(Search, {
      className: "absolute h-4 w-4 mt-3 ml-3"
    }), /*#__PURE__*/_jsx(Input, {
      className: "w-full lg:w-64 h-8 rounded-full pl-10 active:border-violet-400",
      type: "text",
      placeholder: "Search...",
      value: props.searchQuery,
      onChange: e => props.onChange(e.target.value)
    })]
  });
};
export default SearchInput;